import { useFeatureTheme } from "../context/FeatureThemeContext";
import { Card } from "../components/common/Card";
import { PageHeader } from "../components/common/PageHeader";
import { EmptyState } from "../components/common/EmptyState";

/**
 * Looking for equipment? The suppliers who support A Beekeepers Chronicle (#519).
 *
 * The list comes with the theme payload (global, small, empty until a partner
 * signs). The menu entry is absent while it is empty; the route stays, so a
 * bookmark says so instead of 404ing.
 *
 * The relationship is stated on the page, because a list of vendors that does
 * not say why it is there reads as an ad wall (#460, #296). Links are plain:
 * no tracking, no placement, `rel="noopener noreferrer"`, new tab. Only http(s)
 * is linked (the table has a CHECK; the test is repeated here on purpose).
 */
export function PartnersPage() {
  const { partners = [] } = useFeatureTheme();
  return (
    <div>
      <PageHeader title="Partners" />
      {partners.length === 0 ? (
        <EmptyState title="No partners yet"
          description="When suppliers sign on to support the app, they are listed here." />
      ) : (
        <>
          <p style={{ marginTop: 0 }}>
            Looking for equipment? These suppliers support A Beekeepers Chronicle.
          </p>
          <p style={{ color: "var(--color-text-muted)" }}>
            They are listed because they support the app. These are plain links:
            nobody pays to appear above anyone else, and nothing in your own
            records is ever changed to favour them.
          </p>
          {partners.map((p) => (
            <Card key={p.partner_id} title={p.name} className="section-spacing">
              {p.description ? <p style={{ marginTop: 0 }}>{p.description}</p> : null}
              {/^https?:\/\//i.test(p.website_url || "") ? (
                <a href={p.website_url} target="_blank" rel="noopener noreferrer">
                  Visit {p.name} ↗
                </a>
              ) : null}
            </Card>
          ))}
        </>
      )}
    </div>
  );
}
